import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { LeadService } from 'src/app/private/services/lead.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-move-to-enrollment',
  imports: [SharedModule],
  templateUrl: './move-to-enrollment.component.html',
  styleUrl: './move-to-enrollment.component.scss'
})
export class MoveToEnrollmentComponent {


  @Output() closeDialog = new EventEmitter();
  @Input() editLeadData: any = {};
  @Output() reload = new EventEmitter<any>();
  isLoading = false;

  constructor(
    private api: LeadService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) { }

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  getFullName(user: any) {
    return [user?.prefix, user?.first_name, user?.last_name]
      .filter(name => !!name)
      .join(' ');
  }

  handleMove() {

    const payload = {
      "organization_id": this.localStorage.getOrganizationId(),
      "campus_id": this.localStorage.getCampusId(),
      "lead_id": this.editLeadData.lead_id,
      "reg_id": this.editLeadData.registration.reg_id,
      "application_id": this.editLeadData.application_data.application_id,
      "course_id": this.editLeadData.application_data.course_id,
      "remarks": "",
      "application_date": this.editLeadData.application_data.application_date,
      "user_id": this.editLeadData.application_data.user_id,
      "enrollment_date": new Date().toISOString().split('T')[0],
      "enrollment_status": "Under Review",
      "assign_to": this.editLeadData.application_data.assign_to,
      "documents_statuses": {
      },
      "payment_status": "Pending",
      "payment_details": {
      },
      "mode_of_study": "",
      "document_status": this.editLeadData.registration.document_status,
      "guardian_name": this.editLeadData.registration.guardian_name,
      "guardian_contact": this.editLeadData.registration.guardian_contact,
      "is_student_profile" : this.editLeadData.is_student_profile
    }


    this.isLoading = true;

    this.api.moveApplicationToEnrollment(payload).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.reload.emit();
        this.closeDialog.emit();
      },
      error: (error) => {
        this.isLoading = false;
      }
    }
    );

  }


}
